module.exports = __webpack_public_path__ + "static/media/KLIMA.efa9b179.png";